import { useAppSelector } from '@store';
import ConfirmPopup from '../../components/user-roles/confirm-popup/confirm-popup';
import { ColumnWithConfirmTypes } from './types';

const ColumnWithConfirmHOC = ({
  children,
  onSubmit,
  onCancel,
  editIsLoading,
  globalError,
  buttonText,
}: ColumnWithConfirmTypes): React.JSX.Element => {
  const {
    isLoading,
    // usersWithCustomPerms,
    // usersWithDefaultPerms,
    popupIsOpen,
  } = useAppSelector((state) => state.notificationSettings.templates);

  return (
    <>
      {children}
      {popupIsOpen && (
        <ConfirmPopup
          // usersWithCustomPerms={usersWithCustomPerms}
          // usersWithDefaultPerms={usersWithDefaultPerms}
          isLoading={isLoading as boolean}
          onSubmit={onSubmit}
          onCancel={onCancel}
          globalError={globalError}
          editIsLoading={editIsLoading}
          text={editIsLoading ? 'Loading...' : buttonText}
        />
      )}
      <div id="archive-popup" />
    </>
  );
};

export default ColumnWithConfirmHOC;
